import * as React from 'react';
import ZoomControl from './ZoomControl';
import VehicleFocus from './VehicleFocus';

interface IToolbarProps {
  googleMap: google.maps.Map | undefined;
  vehicleFocusControl: boolean;
}

function ToolbarLayer(props: IToolbarProps): JSX.Element | null {
  if (!props.googleMap) {
    return null;
  }

  return (
    <div>
      <div className="b-map-custom-control b-map-custom-control--right" style={{ bottom: '30px' }}>
        {props.vehicleFocusControl && <VehicleFocus />}
        <ZoomControl map={props.googleMap} />
      </div>
    </div>
  );
}

export default ToolbarLayer;
